import { useQuery } from "@tanstack/react-query";

import { useAppContext } from "./useAppContext";
import { useAttributes } from "./useAttributes";
import { useClient } from "./useClient";

export function useCart() {
	const client = useClient();

	const { reactQueryNoReloadOptions } = useAppContext();

	const { selectedAttributeCode } = useAttributes();

	const result = useQuery(
		["shopping-cart", selectedAttributeCode],
		() => {
			return client.getShoppingCartInfoAsync(selectedAttributeCode);
		},
		{
			...reactQueryNoReloadOptions,
			retry: false,
		},
	);

	return result.isSuccess ? result.data : undefined;
}
